import { apiGet, systemRequestConfig } from '@api/api.utils'
// import { IResponseCommon } from "@api/common.types"

import { 
    IResponseOnlineOperators,
    IResponseStatsAppYear,
    IResponseStatsAppMonth,
    IResponseStatsAppDays,
    IResponseStatsContractsYear,
    IResponseStatsContractsMonth,
    IResponseStatsContractsDays,
} from "./api.types"

import { 

} from "./state.types"


/** Маршрут на сервер */
const route = '/dashboard'


/** Online операторы для dashboard */
export const getOnlineOperators = (isSystemRequest: boolean = false): Promise<IResponseOnlineOperators> =>
    apiGet<IResponseOnlineOperators>(`${route}/getOnlineOperators`, isSystemRequest ? systemRequestConfig() : undefined)


/** Статистика - Заявки по годам */
export const getStatsAppYearsModskill = (isSystemRequest: boolean = false): Promise<IResponseStatsAppYear> => 
    apiGet<IResponseStatsAppYear>(`${route}/getStatsAppYearsModskill`, isSystemRequest ? systemRequestConfig() : undefined)

/** Статистика - Заявки по годам */
export const getStatsAppYearsYaskill = (isSystemRequest: boolean = false): Promise<IResponseStatsAppYear> => 
    apiGet<IResponseStatsAppYear>(`${route}/getStatsAppYearsYaskill`, isSystemRequest ? systemRequestConfig() : undefined)



/** Статистика - Заявки по месяцам */
export const getStatsAppMonthModskill = (isSystemRequest: boolean = false): Promise<IResponseStatsAppMonth> => 
    apiGet<IResponseStatsAppMonth>(`${route}/getStatsAppMonthModskill`, isSystemRequest ? systemRequestConfig() : undefined)

/** Статистика - Заявки по месяцам */
export const getStatsAppMonthYaskill = (isSystemRequest: boolean = false): Promise<IResponseStatsAppMonth> => 
    apiGet<IResponseStatsAppMonth>(`${route}/getStatsAppMonthYaskill`, isSystemRequest ? systemRequestConfig() : undefined)



/** Статистика - Заявки по дням */
export const getStatsAppDaysModskill = (year: number, month: number, isSystemRequest: boolean = false): Promise<IResponseStatsAppDays> => 
    apiGet<IResponseStatsAppDays>(`${route}/getStatsAppDaysModskill`, isSystemRequest ? systemRequestConfig({params: {year, month}}) : {params: {year, month}})

/** Статистика - Заявки по дням */
export const getStatsAppDaysYaskill = (year: number, month: number, isSystemRequest: boolean = false): Promise<IResponseStatsAppDays> => 
    apiGet<IResponseStatsAppDays>(`${route}/getStatsAppDaysYaskill`, isSystemRequest ? systemRequestConfig({params: {year, month}}) : {params: {year, month}})



/** Статистика - Договоры по годам */
export const getStatsContractsYearsModskill = (isSystemRequest: boolean = false): Promise<IResponseStatsContractsYear> =>
    apiGet<IResponseStatsContractsYear>(`${route}/getStatsContractsYearsModskill`, isSystemRequest ? systemRequestConfig() : undefined)

/** Статистика - Договоры по годам */
export const getStatsContractsYearsYaskill = (isSystemRequest: boolean = false): Promise<IResponseStatsContractsYear> =>
    apiGet<IResponseStatsContractsYear>(`${route}/getStatsContractsYearsYaskill`, isSystemRequest ? systemRequestConfig() : undefined)



/** Статистика - Договоры по месяцам */
export const getStatsContractsMonthModskill = (isSystemRequest: boolean = false): Promise<IResponseStatsContractsMonth> =>
    apiGet<IResponseStatsContractsMonth>(`${route}/getStatsContractsMonthModskill`, isSystemRequest ? systemRequestConfig() : undefined)

/** Статистика - Договоры по месяцам */
export const getStatsContractsMonthYaskill = (isSystemRequest: boolean = false): Promise<IResponseStatsContractsMonth> =>
    apiGet<IResponseStatsContractsMonth>(`${route}/getStatsContractsMonthYaskill`, isSystemRequest ? systemRequestConfig() : undefined)



/** Статистика - Договоры по дням */
export const getStatsContractsDaysModskill = (year: number, month: number, isSystemRequest: boolean = false): Promise<IResponseStatsContractsDays> =>
    apiGet<IResponseStatsContractsDays>(`${route}/getStatsContractsDaysModskill`, isSystemRequest ? systemRequestConfig({params: {year, month}}) : {params: {year, month}})

/** Статистика - Договоры по дням */
export const getStatsContractsDaysYaskill = (year: number, month: number, isSystemRequest: boolean = false): Promise<IResponseStatsContractsDays> =>
    apiGet<IResponseStatsContractsDays>(`${route}/getStatsContractsDaysYaskill`, isSystemRequest ? systemRequestConfig({params: {year, month}}) : {params: {year, month}})
